<template>
  <div class="solar-plant-items">
    <b-row class="pb-2 border-bottom" v-if="shouldShowManagementSystemWarning">
      <b-col lg="12">
        <div class="warning-toast">
          {{ $t('solar_plant_gt_7kwp_warning') }}
        </div>
      </b-col>
    </b-row>

    <!-- Inverters Section -->
    <b-row class="py-3 border-bottom">
      <b-col lg="12">
        <div class="inverters-section">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>{{ $t('inverters') }}</strong>
            <button
              class="btn btn-sm btn-success"
              @click="openItemBrowser"
              type="button"
              style="white-space: nowrap"
            >
              <i class="fa fa-plus mr-1"></i>
              {{ $t('add_inverter') }}
            </button>
          </div>
          <SolarPlantInverters
            :inverters="project.solarPlant.inverters || []"
            @update-inverters="updateInverters"
          />
        </div>
      </b-col>
    </b-row>

    <!-- <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('inverter1') + ' (' + $t('legacy') + ')'"
          label-for="inverter1"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementsValidState('inverter1')"
        >
          <multiselect
            :placeholder="$t('inverter1')"
            v-model="project.solarPlant.inverter1Item"
            id="inverter1"
            :options="filteredInverters"
            :allow-empty="true"
            :show-labels="false"
            track-by="_id"
            v-on:search-change="onInverterSearch"
            :internal-search="false"
            :preserve-search="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.inverter?.manufacturer }} - {{ option.inverter?.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.inverter?.manufacturer }} - {{ option.inverter?.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1">{{ inverter1Power }} kW</div>
      </b-col>
    </b-row> -->

    <!-- <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('inverter2') + ' (' + $t('legacy') + ')'"
          label-for="inverter2"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('inverter2')"
            v-model="project.solarPlant.inverter2Item"
            id="inverter2"
            :options="filteredInverters"
            :allow-empty="true"
            :show-labels="false"
            track-by="_id"
            v-on:search-change="onInverterSearch"
            :internal-search="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.inverter?.manufacturer }} - {{ option.inverter?.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.inverter?.manufacturer }} - {{ option.inverter?.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1">{{ inverter2Power }} kW</div>
      </b-col>
    </b-row> -->

    <!-- Solar Panels Section -->
    <b-row class="py-3 border-bottom">
      <b-col lg="12">
        <div class="solar-panels-section">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>{{ $t('solarPanels') }}</strong>
            <button
              class="btn btn-sm btn-success"
              @click="openSolarPanelBrowser"
              type="button"
              style="white-space: nowrap"
            >
              <i class="fa fa-plus mr-1"></i>
              {{ $t('add_solar_panel') }}
            </button>
          </div>
          <SolarPlantSolarPanels
            :solar-panels="project.solarPlant.solarPanels || []"
            @update-solar-panels="updateSolarPanels"
          />
        </div>
      </b-col>
    </b-row>

    <!-- <b-row>
      <b-col lg="10" md="6" sm="12">
        <strong>{{ $t('solarPanel') }} ({{ $t('legacy') }})</strong>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 ">
          <strong>{{ solarPanelsOverallPower }} kWp</strong>
        </div>
      </b-col>
    </b-row> -->

    <!-- <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('solarPanel')"
          label-for="solarPanel"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementsValidState('solarPanel')"
        >
          <multiselect
            :placeholder="$t('solarPanel')"
            v-model="project.solarPlant.solarPanelItem"
            id="solarPanel"
            :options="filteredSolarPanels"
            track-by="_id"
            v-on:search-change="onSolarPanelSearch"
            :internal-search="false"
            :show-labels="true"
            :deselectLabel="$t('deselectLabel')"
            selectLabel=""
            selectedLabel=""
            :preserve-search="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.solarPanel?.manufacturer || option.manufacturer }} -
              {{ option.solarPanel?.type || option.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.solarPanel?.manufacturer || option.manufacturer }} -
              {{ option.solarPanel?.type || option.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1">
          {{ solarPanelPower }}
          Wp
        </div>
      </b-col>
    </b-row> -->

    <!-- <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('solarPanelCount')"
          label-for="solarPanelCount"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementsValidState('solarPanelCount')"
        >
          <b-form-input
            v-model="project.solarPlant.solarPanelCount"
            type="text"
            :placeholder="$t('solarPanelCount')"
            :state="requirementsValidState('solarPanelCount')"
          />
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12"> </b-col>
    </b-row> -->

    <b-row class="py-3 border-bottom">
      <b-col lg="10" md="6" sm="12">
        <strong>{{ $t('battery') }}</strong>
      </b-col>

      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('battery')"
          label-for="battery"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('battery')"
            v-model="project.solarPlant.batteryItem"
            id="battery"
            :options="filteredBatteries"
            :allow-empty="true"
            :show-labels="false"
            track-by="_id"
            v-on:search-change="onBatterySearch"
            :internal-search="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.battery?.manufacturer }} - {{ option.battery?.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.battery?.manufacturer }} - {{ option.battery?.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1">{{ batteryCapacity }} kWh</div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="10" md="6" sm="12"> </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1" v-if="project.solarPlant.battery">
          <span>{{ $t(project.solarPlant.battery.connectionType) }}</span>
        </div>
      </b-col>
    </b-row>

    <b-row class="py-3">
      <b-col lg="10" md="6" sm="12">
        <strong>{{ $t('additionalComponents') }}</strong>
      </b-col>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('energyFlowDirectionSensor_short')"
          label-for="energyFlowDirectionSensor"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('energyFlowDirectionSensor_short')"
            v-model="project.solarPlant.energyFlowDirectionSensorItem"
            id="energyFlowDirectionSensor"
            :options="filteredEnergyFlowFirectionSensors"
            :allow-empty="true"
            :show-labels="false"
            track-by="_id"
            v-on:search-change="onEnergyFlowDirectionSensorSearch"
            :internal-search="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.energyFlowDirectionSensor?.manufacturer }} -
              {{ option.energyFlowDirectionSensor?.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.energyFlowDirectionSensor?.manufacturer }} -
              {{ option.energyFlowDirectionSensor?.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12"> </b-col>

      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('wallbox')"
          label-for="wallbox"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('wallbox')"
            v-model="project.solarPlant.wallboxItem"
            id="wallbox"
            :options="filteredWallboxes"
            :allow-empty="true"
            :show-labels="false"
            track-by="_id"
            v-on:search-change="onWallboxSearch"
            :internal-search="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.wallbox?.manufacturer }} - {{ option.wallbox?.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.wallbox?.manufacturer }} - {{ option.wallbox?.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1">
          <span v-if="project.solarPlant.wallbox">{{
            project.solarPlant.wallbox.maxNetInputPower
          }}</span>
          kW
        </div>
      </b-col>

      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('emergencyPowerState')"
          label-for="emergencyPowerState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('emergencyPowerState')"
            v-model="project.solarPlant.emergencyPowerState"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="false"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><b-badge :variant="yesNoColor(option)">{{ $t(option) }}</b-badge></template
            >
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="yesNoColor(option)">
                {{ $t(option) }}
              </b-badge></template
            >
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12"> </b-col>
    </b-row>

    <!-- Item Browser Modal for Inverters -->
    <Dialog
      :header="$t('add_inverter')"
      :visible.sync="showItemBrowserModal"
      :modal="true"
      :style="{ width: '90vw', maxWidth: '1600px' }"
      :contentStyle="{ height: '70vh', overflow: 'visible' }"
      :closable="true"
    >
      <ItemBrowser
        context="project"
        :show-pricing="false"
        :show-filters="false"
        :filter-inverters-only="true"
        default-view-mode="cards"
        @add="addInverterToProject"
      />

      <template #footer>
        <button class="btn btn-default" @click="closeItemBrowser">
          {{ $t('close') }}
        </button>
      </template>
    </Dialog>

    <!-- Item Browser Modal for Solar Panels -->
    <Dialog
      :header="$t('add_solar_panel')"
      :visible.sync="showSolarPanelBrowserModal"
      :modal="true"
      :style="{ width: '90vw', maxWidth: '1600px' }"
      :contentStyle="{ height: '70vh', overflow: 'visible' }"
      :closable="true"
    >
      <ItemBrowser
        context="project"
        :show-pricing="false"
        :show-filters="false"
        :filter-solar-panels-only="true"
        default-view-mode="cards"
        @add="addSolarPanelToProject"
      />

      <template #footer>
        <button class="btn btn-default" @click="closeSolarPanelBrowser">
          {{ $t('close') }}
        </button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import Dialog from 'primevue/dialog';
import ItemBrowser from '@/components/ItemBrowser.vue';
import SolarPlantInverters from '@/components/SolarPlant/SolarPlantInverters.vue';
import SolarPlantSolarPanels from '@/components/SolarPlant/SolarPlantSolarPanels.vue';
import {
  formatSolarPanelsOverallPower,
  formatSolarPanelPower,
  formatBatteryCapacity,
} from '@/helpers/projects';
import {
  formatInverterApparentPowerOverall,
  formatInverterNominalPowerOverall,
  formatInverter1Power,
  formatInverter2Power,
} from '@/helpers/inverter';
import { yesNo } from '@/helpers/enums';
import { getYesNoStateColor } from '@/helpers/colors';
import { management_system_required } from '@/helpers/solarPlant';

export default {
  components: {
    Multiselect,
    Dialog,
    ItemBrowser,
    SolarPlantInverters,
    SolarPlantSolarPanels,
  },
  props: {
    project: { type: Object, required: true },
  },
  data() {
    return {
      showItemBrowserModal: false,
      showSolarPanelBrowserModal: false,
      filteredSolarPanels: [],
      filteredInverters: [],
      filteredBatteries: [],
      filteredEnergyFlowFirectionSensors: [],
      filteredWallboxes: [],
    };
  },
  computed: {
    ...mapGetters(['getItemsBySolarPlant']),
    solarPanelsOverallPower() {
      return formatSolarPanelsOverallPower(this.project);
    },
    solarPanelPower() {
      return formatSolarPanelPower(this.project);
    },
    inverterApparentPowerOverall() {
      return formatInverterApparentPowerOverall(this.project);
    },
    InverterNominalPowerOverall() {
      return formatInverterNominalPowerOverall(this.project);
    },
    inverter1Power() {
      return formatInverter1Power(this.project);
    },
    inverter2Power() {
      return formatInverter2Power(this.project);
    },
    batteryCapacity() {
      return formatBatteryCapacity(this.project);
    },
    optionsYesNo() {
      return yesNo();
    },
    invalidFeedbackNA() {
      return 'Voraussetzung NA';
    },
    shouldShowManagementSystemWarning() {
      return management_system_required(this.project.solarPlant);
    },
  },
  methods: {
    ...mapActions(['fetchItemsBySolarPlant']),
    yesNoColor(state) {
      return getYesNoStateColor(state);
    },
    openItemBrowser() {
      this.showItemBrowserModal = true;
    },
    closeItemBrowser() {
      this.showItemBrowserModal = false;
    },
    addInverterToProject(item) {
      console.log('Adding inverter to project:', item);

      // Ensure inverters array exists
      if (!this.project.solarPlant.inverters) {
        this.$set(this.project.solarPlant, 'inverters', []);
      }

      // Check if item already exists in inverters list
      const existingInverterIndex = this.project.solarPlant.inverters.findIndex(
        (inv) => inv.item?._id === item._id || inv.item === item._id
      );

      let updatedInverters;
      const countToAdd = parseInt(item.addRemoveCount || item.quantity || 1, 10);

      if (existingInverterIndex >= 0) {
        // Update count of existing inverter
        updatedInverters = [...this.project.solarPlant.inverters];
        const currentCount = parseInt(updatedInverters[existingInverterIndex].count || 0, 10);
        updatedInverters[existingInverterIndex] = {
          ...updatedInverters[existingInverterIndex],
          count: currentCount + countToAdd,
        };
      } else {
        // Add new inverter to list
        const newInverter = {
          item: item, // Full item object (will be transformed to _id in createPayload)
          count: countToAdd,
        };

        updatedInverters = [...this.project.solarPlant.inverters, newInverter];
      }

      // Update the project
      this.project.solarPlant.inverters = updatedInverters;
    },
    updateInverters(updatedInverters) {
      this.project.solarPlant.inverters = updatedInverters;
    },
    openSolarPanelBrowser() {
      this.showSolarPanelBrowserModal = true;
    },
    closeSolarPanelBrowser() {
      this.showSolarPanelBrowserModal = false;
    },
    addSolarPanelToProject(item) {
      console.log('Adding solar panel to project:', item);

      // Ensure solarPanels array exists
      if (!this.project.solarPlant.solarPanels) {
        this.$set(this.project.solarPlant, 'solarPanels', []);
      }

      // Check if item already exists in solarPanels list
      const existingSolarPanelIndex = this.project.solarPlant.solarPanels.findIndex(
        (panel) => panel.item?._id === item._id || panel.item === item._id
      );

      let updatedSolarPanels;
      const countToAdd = parseInt(item.addRemoveCount || item.quantity || 1, 10);

      if (existingSolarPanelIndex !== -1) {
        // Update existing solar panel count
        const currentCount = parseInt(
          this.project.solarPlant.solarPanels[existingSolarPanelIndex].count || 0,
          10
        );
        updatedSolarPanels = [...this.project.solarPlant.solarPanels];
        updatedSolarPanels[existingSolarPanelIndex] = {
          ...updatedSolarPanels[existingSolarPanelIndex],
          count: currentCount + countToAdd,
        };
      } else {
        // Add new solar panel to list
        const newSolarPanel = {
          item: item, // Full item object (will be transformed to _id in createPayload)
          count: countToAdd,
        };

        updatedSolarPanels = [...this.project.solarPlant.solarPanels, newSolarPanel];
      }

      // Update the project
      this.project.solarPlant.solarPanels = updatedSolarPanels;
    },
    updateSolarPanels(updatedSolarPanels) {
      this.project.solarPlant.solarPanels = updatedSolarPanels;
    },
    onInverterSearch(query) {
      this.filteredInverters = this.getItemsBySolarPlant('INVERTER').filter((item) => {
        if (!query) return true;
        return (
          item.inverter.manufacturer.toLowerCase().includes(query.toLowerCase()) ||
          item.inverter.type.toLowerCase().includes(query.toLowerCase())
        );
      });
    },
    onBatterySearch(query) {
      this.filteredBatteries = this.getItemsBySolarPlant('BATTERY').filter((battery) => {
        if (!query) return true;
        return (
          battery.manufacturer.toLowerCase().includes(query.toLowerCase()) ||
          battery.type.toLowerCase().includes(query.toLowerCase())
        );
      });
    },
    onSolarPanelSearch(query) {
      this.filteredSolarPanels = this.getItemsBySolarPlant('SOLAR_PANELS').filter((solarPanel) => {
        if (!query) return true;
        return (
          solarPanel.manufacturer.toLowerCase().includes(query.toLowerCase()) ||
          solarPanel.type.toLowerCase().includes(query.toLowerCase())
        );
      });
    },
    onWallboxSearch(query) {
      this.filteredWallboxes = this.getItemsBySolarPlant('WALL_BOX').filter((wallbox) => {
        if (!query) return true;
        return (
          wallbox.manufacturer.toLowerCase().includes(query.toLowerCase()) ||
          wallbox.type.toLowerCase().includes(query.toLowerCase())
        );
      });
    },
    onEnergyFlowDirectionSensorSearch(query) {
      this.filteredEnergyFlowFirectionSensors = this.getItemsBySolarPlant(
        'ENERGY_FLOW_SENSOR'
      ).filter((sensor) => {
        if (!query) return true;
        return (
          sensor.manufacturer.toLowerCase().includes(query.toLowerCase()) ||
          sensor.type.toLowerCase().includes(query.toLowerCase())
        );
      });
    },
    requirementsValidState(field) {
      if (!this.project.netRegistrationRequirements) return false;

      const requirement = this.project.netRegistrationRequirements.find(
        (requirement) => requirement.name === field
      );
      return requirement && requirement.fullfilledState === 'YES';
    },
    async fetchItemsAndSetFiltered(solarPlantType) {
      try {
        await this.fetchItemsBySolarPlant(solarPlantType);
        return this.getItemsBySolarPlant(solarPlantType) || [];
      } catch (error) {
        console.error(`Failed to fetch items for type ${solarPlantType}:`, error);
        return [];
      }
    },
    async setup() {
      try {
        const [inverters, batteries, sensors, wallboxes, solarPanels] = await Promise.all([
          this.fetchItemsAndSetFiltered('INVERTER'),
          this.fetchItemsAndSetFiltered('BATTERY'),
          this.fetchItemsAndSetFiltered('ENERGY_FLOW_SENSOR'),
          this.fetchItemsAndSetFiltered('WALL_BOX'),
          this.fetchItemsAndSetFiltered('SOLAR_PANELS'),
        ]);

        this.filteredInverters = inverters;
        this.filteredBatteries = batteries;
        this.filteredEnergyFlowFirectionSensors = sensors;
        this.filteredWallboxes = wallboxes;
        this.filteredSolarPanels = solarPanels;
      } catch (error) {
        console.error('Error in setup:', error);
      }
    },
  },
  async mounted() {
    await this.setup();

    // Initialize inverters array if it doesn't exist (for existing projects)
    if (!this.project.solarPlant.inverters) {
      this.$set(this.project.solarPlant, 'inverters', []);
    }

    // Initialize solarPanels array if it doesn't exist (for existing projects)
    if (!this.project.solarPlant.solarPanels) {
      this.$set(this.project.solarPlant, 'solarPanels', []);
    }
  },
};
</script>
